import pdfResults from "./pdfResults";

class Node {
  constructor(id, level, filterId, pdfResults, children) {
    this.id = id;
    this.level = level;
    this.filterId = filterId;
    this.pdfResults = pdfResults;
    this.children = children;
  }
}

// Node(id, level, filterId, [pdfResults], [children])
const treeNodes = [
  new Node(0, -1, -1, [], [1, 2, 3, 4]),
  new Node(1, 0, 1, [1, 2, 3, 4, 5, 6], [5, 6]),
  new Node(2, 0, 2, [7, 8, 9, 10, 11, 12], [7, 8]),
  new Node(
    3,
    0,
    3,
    [13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25],
    [9, 10]
  ),
  new Node(4, 0, 4, [26, 27, 28, 29, 30, 31, 32, 33, 34], [11, 12]),
  new Node(5, 1, 6, [3, 4, 5, 6], [13]),
  new Node(6, 1, 5, [1, 2], [14]),
  new Node(7, 1, 6, [9, 10, 11, 12], [15]),
  new Node(8, 1, 5, [7, 8], [16]),
  new Node(9, 1, 6, [17, 18, 19, 20, 21, 22, 23, 24, 25], [17, 18]),
  new Node(10, 1, 5, [13, 14, 15, 16], [19, 20]),
  new Node(11, 1, 6, [28, 29, 30, 31, 32, 33, 34], [21, 22]),
  new Node(12, 1, 5, [26, 27], [23, 24]),
  new Node(13, 2, 9, [3, 4, 5, 6], [25]),
  new Node(14, 2, 9, [1, 2], [26]),
  new Node(15, 2, 9, [9, 10, 11, 12], [27]),
  new Node(16, 2, 9, [7, 8], [28]),
  new Node(17, 2, 9, [19, 20, 21, 22, 24, 25], [29]),
  new Node(18, 2, 7, [17, 18, 23], []),
  new Node(19, 2, 9, [16], [30]),
  new Node(20, 2, 7, [13, 14, 15], [31]),
  new Node(21, 2, 9, [31, 32, 33, 34], []),
  new Node(22, 2, 8, [28, 29, 30], []),
  new Node(23, 2, 9, [27], [32]),
  new Node(24, 2, 8, [26], [33]),
  new Node(25, 3, 10, [3, 4], [34]),
  new Node(26, 3, 10, [1], [35]),
  new Node(27, 3, 10, [9, 10], [36]),
  new Node(28, 3, 10, [7], [37]),
  new Node(29, 3, 10, [19, 20, 21, 22, 24, 25], [38, 39]),
  new Node(30, 3, 10, [16], [40]),
  new Node(31, 3, 11, [13], [41]),
  new Node(32, 3, 10, [27], []),
  new Node(33, 3, 11, [26], []),
  new Node(34, 4, 12, [5, 6], []),
  new Node(35, 4, 12, [2], []),
  new Node(36, 4, 12, [11, 12], []),
  new Node(37, 4, 12, [8], []),
  new Node(38, 4, 13, [24, 25], []),
  new Node(39, 4, 12, [19, 20, 21, 22], []),
  new Node(40, 4, 13, [16], []),
  new Node(41, 4, 12, [14, 15], []),
];

export function bfs(filtersApplied) {
  let visited = new Set();
  let queue = [treeNodes[0]];
  let result = new Set();
  let currentLevel = -1;

  while (queue.length) {
    let node = queue.shift();
    if (visited.has(node)) {
      continue;
    }
    visited.add(node);

    // if we're proceeding to the next level and a filter is applied at the next level, clear the result
    if (currentLevel < node.level && filtersApplied[node.level] !== -1) {
      result.clear();
    }
    currentLevel = node.level;
    // if the current filter is not applied or if filter is applied and this is the node that represents the filter,
    // add the pdf results to the result set and add the children to the queue
    if (
      filtersApplied[currentLevel] === -1 ||
      filtersApplied[currentLevel] === node.filterId
    ) {
      for (let pdfResults of node.pdfResults) {
        result.add(pdfResults);
      }
      for (let childId of node.children) {
        queue.push(treeNodes[childId]);
      }
    }
    // if current node is a root node
    else if (currentLevel === -1) {
      for (let childId of node.children) {
        queue.push(treeNodes[childId]);
      }
    }
  }

  // // convert result set to array of pdfs
  result = Array.from(result).map((pdfId) => pdfResults[pdfId]);
  return result;
}
